<template>
    <v-container fluid>
        <v-btn
            :loading="providersWithInfo === null"
            @click="newProvider"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row align="center" no-gutters>
            <v-col cols="12" justify="center" lg="4" sm="6">
                <v-subheader>
                    <h2>Providers</h2>
                </v-subheader>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
        </v-row>
        <v-container>
            <v-row justify="center" v-if="providersWithInfo === null">
                <v-col :key="i" cols="12" lg="6" v-for="i in 6">
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row justify="center" v-else>
                <v-col
                    :key="providerWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="providerWithInfo in providersWithInfo"
                >
                    <v-card
                        @click="loadProviderForm(providerWithInfo.entity)"
                        class="provider-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title>
                            {{ providerWithInfo.entity.practiceName }}
                            <br />
                            <v-card-subtitle>{{
                                providerWithInfo.entity.practiceNumber
                            }}</v-card-subtitle>
                        </v-card-title>
                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-between" no-gutters>
                                    <v-col class="text-center" cols="6" md="3">
                                        <v-card class="pa-2 ma-2">
                                            Open Queries
                                            <br />
                                            <h3>
                                                {{
                                                    providerWithInfo.entity
                                                        .numberOfUnResolvedQueries
                                                }}
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col class="text-center" cols="6" md="3">
                                        <v-card class="pa-2 ma-2">
                                            Proxy Doc
                                            <br />
                                            <h3>
                                                <v-icon
                                                    :color="
                                                        providerWithInfo.entity
                                                            .proxyDocumentId > 0
                                                            ? 'success'
                                                            : 'error'
                                                    "
                                                    >{{
                                                        providerWithInfo.entity
                                                            .proxyDocumentId > 0
                                                            ? "mdi-check"
                                                            : "mdi-close"
                                                    }}</v-icon
                                                >
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col class="text-center" cols="6" md="3">
                                        <v-card class="pa-2 ma-2">
                                            Batch No
                                            <br />
                                            <h3>
                                                <span
                                                    v-if="
                                                        providerWithInfo.entity
                                                            .currentBatchId
                                                    "
                                                    >{{
                                                        providerWithInfo.entity
                                                            .currentBatchId
                                                    }}</span
                                                >
                                                <v-icon color="error" v-else
                                                    >mdi-close</v-icon
                                                >
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col class="text-center" cols="6" md="3">
                                        <v-card class="pa-2 ma-2">
                                            Latest Account
                                            <br />
                                            <h3>
                                                <span
                                                    v-if="
                                                        providerWithInfo.info
                                                            .latestAccountDate
                                                    "
                                                    >{{
                                                        providerWithInfo.info.latestAccountDate.substring(
                                                            0,
                                                            10
                                                        )
                                                    }}</span
                                                >
                                                <v-icon color="error" v-else
                                                    >mdi-close</v-icon
                                                >
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                        <v-card-text>
                            <v-chip class="ma-1" color="secondary" dark small>
                                <v-icon left small>mdi-doctor</v-icon>
                                {{ providerWithInfo.entity.doctorName }}
                            </v-chip>
                            <v-chip class="ma-1" color="secondary" dark small>
                                <v-icon left small>mdi-at</v-icon>
                                {{ providerWithInfo.entity.emailAddress }}
                            </v-chip>
                            <v-chip class="ma-1" color="secondary" dark small>
                                <v-icon left small>mdi-phone-classic</v-icon>
                                {{ providerWithInfo.entity.cellNumber }}
                            </v-chip>
                            <v-chip class="ma-1" color="secondary" dark small
                                >BHF:
                                {{ providerWithInfo.entity.bhfNumber }}</v-chip
                            >

                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="
                                    providerDisciplines.find(
                                        (x) =>
                                            x.key ==
                                            providerWithInfo.entity
                                                .primaryDiscipline
                                    )
                                "
                                >{{
                                    providerDisciplines.find(
                                        (x) =>
                                            x.key ==
                                            providerWithInfo.entity
                                                .primaryDiscipline
                                    ).value
                                }}</v-chip
                            >
                            <template
                                v-for="discipline in providerWithInfo.entity
                                    .disciplines"
                            >
                                <v-chip
                                    :key="discipline"
                                    class="ma-1"
                                    color="secondary"
                                    dark
                                    small
                                    v-if="
                                        providerDisciplines.find(
                                            (x) => x.key == discipline
                                        )
                                    "
                                    >{{
                                        providerDisciplines.find(
                                            (x) => x.key == discipline
                                        ).value
                                    }}</v-chip
                                >
                            </template>
                        </v-card-text>
                        <v-card-text class="pt-0">
                            Face Value:
                            <strong
                                >R
                                {{
                                    providerWithInfo.info.totalAmount.toFixed(2)
                                }}</strong
                            >
                            <br />Purchase Amount:
                            <strong
                                >R
                                {{
                                    providerWithInfo.info.billedAmount.toFixed(
                                        2
                                    )
                                }}</strong
                            >
                            <!--<br />Purchase Amount Calculated:
                            <strong
                                >R
                                {{
                                    providerWithInfo.info.billedCalculatedAmount.toFixed(
                                        2
                                    )
                                }}</strong
                            >-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="providerFormVisible"
        >
            <v-sheet class="base-background" min-height="100%">
                <v-toolbar color="secondary darken-1" dark>
                    <v-btn @click="closeProviderForm" dark icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Provider Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row align="center" justify="center" v-if="true">
                        <provider-form
                            :disciplines="providerDisciplines"
                            :key="providerFormKey"
                            :provider-in="providerFormProvider"
                            @close="closeProviderForm"
                            @deleted="deleteProvider"
                            @saved="updateProvider"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import providerForm from "../components/forms/ProviderForm";
import Provider from "../models/Provider.model";
import uuid4 from "../helpers/uuid4";

export default {
    name: "Providers",
    data: () => ({
        //main data
        providersWithInfo: null,
        providerDisciplines: null,
        //pagination
        pageNo: 1,
        pageSize: 6,
        pagesCount: 0,
        searchString: "",
        orderBy: "",
        sortOrder: 0,
        paginationTimeout: null,
        requestId: uuid4(),

        //form data
        providerFormVisible: false,
        providerFormKey: 0,
        providerFormProvider: new Provider(),

        //
    }),
    mounted: async function () {
        this.providerDisciplines = await this.$store.dispatch(
            "providers/getDisciplines"
        );
        this.getProviders();
    },
    components: {
        providerForm,
        //
    },
    methods: {
        async getProviders() {
            var requestId = (this.requestId = uuid4());

            var providersResponse = await this.$store.dispatch(
                "providers/get",
                {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                    },
                    requestId: requestId,
                }
            );

            if (this.requestId == providersResponse.requestId) {
                this.providersWithInfo = providersResponse.data.page;
                this.pagesCount = Math.ceil(
                    providersResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.providersWithInfo !== null) this.providersWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getProviders,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(1000);
        },
        newProvider() {
            var provider = new Provider();
            provider.id = 0;
            provider.isActive = true;
            this.loadProviderForm(provider);
        },
        loadProviderForm(provider) {
            this.providerFormProvider = new Provider().set(provider);
            this.providerFormKey = provider.id;
            this.providerFormVisible = true;
        },
        closeProviderForm() {
            this.providerFormVisible = false;
            this.providerFormProvider = new Provider();
            this.providerFormKey = null;
        },
        updateProvider() {
            this.paginationDebounce(0);
            /*
            this.providerApplyDisciplineName(providerWithInfo.entity);
            var updateIndex = this.providersWithInfo.findIndex(
                x => x.entity.id == providerWithInfo.entity.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.providersWithInfo,
                    updateIndex,
                    providerWithInfo
                );
            else if (updateIndex == -1) this.getProviders();
            */
            //this.providersWithInfo.push(providerWithInfo);
        },
        deleteProvider() {
            this.paginationDebounce(0);
            /*
            var deletedIndex = this.providersWithInfo.findIndex(
                x => x.entity.id == deletedProvider.id
            );
            if (deletedIndex > -1)
                this.$delete(this.providersWithInfo, deletedIndex);
                */
        },
    },
};
</script>

<style lang="stylus" scoped>
.provider-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
